<h1>{{'RESULTS.SECTIONS.BASELINE_FEEDSTOCK_BREAKDOWN_RESULTS' | anessaTranslation: trigger}}</h1>
<div *ngIf="feedstockBreakdownData">
  <!-- SELECTION BOXES -->
  <div class="fl">
    <!-- Media Type Select -->
    <div class="fl-item">
      <mat-form-field floatLabel="never" class="anessa-dropdown">
        <mat-select
          id="baseline-feedstock-breakdown-mediaType_select"
          disableOptionCentering
          multiple
          placeholder="{{'RESULTS.GENERAL.SELECT_MEDIA_TYPE' | anessaTranslation: trigger}}"
          [(value)]="selectedMediaType"
          (valueChange)="optionsChanged()"
          panelClass="anessa-dropdown-panel">
          <ng-container *ngFor="let type of mediaTypes">
            <mat-option
              [value]="type.value"
            >
              {{ type.translationId | anessaTranslation: trigger }}
            </mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- Measurement System Select -->
    <div class="fl-item">
      <mat-form-field floatLabel="never" class="anessa-dropdown">
        <mat-select
          id="baseline-feedstock-breakdown-measurement_select"
          disableOptionCentering
          placeholder="{{'RESULTS.GENERAL.SET_UNIT_TYPE' | anessaTranslation: trigger}}"
          [(value)]="selectedUnitsType"
          (valueChange)="optionsChanged()"
          panelClass="anessa-dropdown-panel">
          <ng-container *ngFor="let type of unitsTypes">
            <mat-option
              [value]="type.value"
            >
              {{ type.translationId | anessaTranslation: trigger }}
            </mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <!-- NO DATA -->
  <div class="fl" *ngIf="!this.feedstockBreakdownData || this.feedstockBreakdownData.length < 1">
    <div class="fl-item">
      <h3>{{'RESULTS.ERRORS.NO_DATA_AVAILABLE' | anessaTranslation: trigger}}</h3>
    </div>
  </div>

  <!-- PIE CHART -->
  <div class="fl" *ngIf="displayGraph">
    <div class="fl-item">
      <app-graph-selector
        [graphType]="'piechart'"
        [graphData]="graphData"
        [precision]="precision"
      ></app-graph-selector>
    </div>
  </div>

  <!-- TABLE  -->
  <div *ngIf="displayTable">
    <results-treetable
      [labelKey]="'COMMON.FEEDSTOCK'"
      [valueKey]="'RESULTS.GENERAL.AMOUNT'"
      [firstColumnHeader]="'COMMON.FEEDSTOCK' | anessaTranslation: trigger"
      [customColumnOrder]="tableHeaders"
      [resultsData]="tableData"
    ></results-treetable>
  </div>
</div>
